import { createSelector } from "@ngrx/store";
import * as fromFeature from "../reducers";
import * as fromActiveSubjects from "../reducers/student-active-subjects.reducer";

export const getActiveSubjectsState = createSelector(
    fromFeature.getStudentCoursesModuleState,
    (state: fromFeature.StudentCoursesState) => state.activeSubjects
);

export const getActiveSubjectsEntities = createSelector(
    getActiveSubjectsState,
    fromActiveSubjects.getActiveSubjectsEntities
);

export const getAllActiveSubjects = createSelector(
    getActiveSubjectsEntities,
    entities => {
        return Array.from(entities.values());
    }
);

export const getActiveSubjectsLoading = createSelector(
    getActiveSubjectsState,
    fromActiveSubjects.getActiveSubjectsLoading
);

export const getActiveSubjectsLoaded = createSelector(
    getActiveSubjectsState,
    fromActiveSubjects.getActiveSubjectsLoaded
);
